var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoading
      ? _c("div", { staticClass: "text-uppercase mt-4 mx-4" }, [
          _c(
            "h6",
            {
              staticClass:
                "primary-heading mb-0 font-weight-bold mb-4 patcraft-text-underline",
              attrs: {
                "data-text": _vm.$resourceString[
                  "product.detail.recommended.weldrods"
                ].slice(0, 3)
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString[
                      "product.detail.recommended.weldrods.header"
                    ]
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "wf-modal-button-close btn button-full",
              attrs: { type: "button" },
              on: {
                click: function() {
                  _vm.hideModal("recommended-weldrods-modal")
                }
              }
            },
            [
              _c("span", {
                staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
                attrs: { "aria-label": "Close modal" }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "weldrods-modal-container" }, [
            _c("div", { staticClass: "row" }, [
              _vm.item.trimColors.length
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "wf-swiper",
                            rawName: "v-wf-swiper",
                            value: {
                              parameters: {
                                initialSlide: _vm.initialSlideIndex,
                                allowTouchMove: false,
                                navigation: {
                                  nextEl: ".wf-swiper-nav-button-next",
                                  prevEl: ".wf-swiper-nav-button-prev"
                                }
                              },
                              slideChangeEvent: _vm.onSlideChange
                            },
                            expression:
                              "{\n              parameters: {\n                initialSlide: initialSlideIndex,\n                allowTouchMove: false,\n                navigation: {\n                  nextEl: '.wf-swiper-nav-button-next',\n                  prevEl: '.wf-swiper-nav-button-prev',\n                },\n              },\n              slideChangeEvent: onSlideChange,\n            }"
                          }
                        ],
                        staticClass: "swiper-container",
                        attrs: { id: "recommended-accessory-swiper" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "main-image mb-3 border border-dark" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "wf-product-quick-view-swatch-slide"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "px-0 w-75 cart-item-model-no"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "swatch-slide-image" },
                                      [
                                        _c("img", {
                                          staticClass: "image",
                                          attrs: {
                                            alt:
                                              _vm.recommendedAccessory
                                                .sellingStyleName,
                                            src: _vm.getImgSrc()
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "swiper-wrapper" },
                          _vm._l(_vm.item.trimColors, function(
                            trimColor,
                            colorIndex
                          ) {
                            return _c(
                              "div",
                              { key: colorIndex, staticClass: "swiper-slide" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "active-color-header position-absolute d-flex flex-column accessoryDescription ml-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { style: { fontWeight: "bold" } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.productData.collectionCode
                                                .description
                                            ) +
                                            " WELDROD\n                    " +
                                            _vm._s(
                                              _vm.recommendedAccessory
                                                .accesoryStyleNumber
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "trimColors" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.item.trimColors.length +
                                              " " +
                                              (_vm.item.trimColors.length !== 1
                                                ? "colors"
                                                : "color")
                                          ) +
                                          "\n                    -\n                    " +
                                          _vm._s(trimColor.colorNumber) +
                                          "\n                  "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons d-none ml-3 mr-3 wf-product-thumbnails-size-small"
                          },
                          [
                            _vm.item.trimColors.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full",
                                    attrs: { type: "button" },
                                    on: { click: _vm.goToPrevColor }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "png-icon png-icon-icons-glyph--ko-chevron-left png-size arrow-left mt-1"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "wf-swiper-thumbnails-container" },
                              _vm._l(_vm.item.trimColors, function(
                                trimColor,
                                colorIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: colorIndex,
                                    staticClass: "wf-swiper-thumbnail"
                                  },
                                  _vm._l(trimColor.imagesInfo, function(
                                    imageInfo
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: imageInfo.url,
                                        staticClass: "imageInfo"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "cart-item-model-no",
                                            on: {
                                              click: function($event) {
                                                return _vm.onThumbnailClick(
                                                  trimColor.colorNumber
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "red-underline"
                                            }),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticClass: "image-thumbnail",
                                              attrs: {
                                                alt: "",
                                                src: imageInfo.url
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.item.trimColors.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full",
                                    attrs: { type: "button" },
                                    on: { click: _vm.goToNextColor }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "png-icon png-icon-icons-glyph--ko-chevron-right arrow-right png-size mt-1"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", [
                  _c("strong", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$resourceString[
                            "product.detail.recommended.weldrods.label"
                          ]
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-unstyled mt-1" }, [
                    _c("li", { staticClass: "weldrods" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.computedAccessoryLabel) +
                          "\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "pr-3" }, [
                    _c("img", {
                      attrs: {
                        height: "100",
                        src: _vm.$helpers.getColorThumbnailImageUrl(
                          _vm.sellingStyleNumber,
                          (_vm.pairedMainProductColor || _vm.selectedColor)
                            .colorNumber
                        ),
                        alt: "img"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "strong",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          width: "90%"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$resourceString[
                                "product.detail.recommended.weldrods.use.with.label"
                              ]
                            ) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "list-unstyled mt-1" }, [
                      _c("li", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.productData.collectionCode.description) +
                            " " +
                            _vm._s(_vm.sellingStyleNumber) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                  COLOR:\n                  " +
                            _vm._s(
                              (_vm.pairedMainProductColor || _vm.selectedColor)
                                .colorNumber
                            ) +
                            "\n                  " +
                            _vm._s(
                              (_vm.pairedMainProductColor || _vm.selectedColor)
                                .colorName
                            ) +
                            "\n                "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.customAccDescription
                  ? _c("div", { staticClass: "description-container" }, [
                      _c("p", {
                        staticClass: "weldrods-description my-3",
                        staticStyle: {
                          "font-size": "11.728px",
                          "text-transform": "none"
                        },
                        domProps: {
                          innerHTML: _vm._s(_vm.customAccDescription)
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "loader-wrapper" },
          [_c("pc-load-more", { attrs: { "load-more": function() {} } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading ? _c("hr", { staticClass: "divider shadow m-0" }) : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-end mr-2 mt-2" },
          [
            _c("wf-add-to-cart-button-only", {
              attrs: {
                "selling-style-number":
                  _vm.recommendedAccessory.accesoryStyleNumber,
                "color-number": _vm.currentColorNumber,
                "is-button": true,
                quantity: 1,
                "save-for-later": false,
                disabled: !_vm.isSampleAvailable,
                cssClasses:
                  "btn btn-primary add-to-cart-mobile-button w-auto px-2 py-2"
              },
              on: {
                "item-added-to-cart": function($event) {
                  return _vm.hideModal("recommended-weldrods-modal")
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }